import { render, staticRenderFns } from "./ComparePlansModal.vue?vue&type=template&id=0d28c896&scoped=true&"
import script from "./ComparePlansModal.vue?vue&type=script&lang=js&"
export * from "./ComparePlansModal.vue?vue&type=script&lang=js&"
import style0 from "./ComparePlansModal.vue?vue&type=style&index=0&id=0d28c896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28c896",
  null
  
)

export default component.exports